import { Box, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Header from '../../components/Header';
import { useTranslation } from '../../hooks/useTranslation';
import { DataContext } from '../../contexts/DataContext';
import PrimaryButton from '../../components/PrimaryButton';
import FloatingActions from '../../components/FloatingActions';
import { PrimaryInput } from '../../components/PrimaryInput';
import LuxService from '../../services/LuxService';
import { ErrorPopUp } from '../../components/ErrorPopUp';
import SecondaryButton from '../../components/SecondaryButton';
const MAX_RETRY = 3;

function SmsConfirmationPage() {
  const { t, i18n } = useTranslation();
  const { steps, currentStep, data, setData, setCurrentStep, trackEvent,flowNumber } =
    useContext(DataContext);
  const [isLoading, setIsLoading] = useState(false);
  const [resendCodeShow, setResendCodeShow] = useState(false);
  const [maxExceeded, setMaxExceeded] = useState(
    data?.smsCodeSentCount > MAX_RETRY
  );
  useEffect(() => {
    trackEvent({ nav_to_phone_code: 1 });
  }, [trackEvent]);
  const [smsConfirmationCode, setSmsConfirmationCode] = useState([
    '',
    '',
    '',
    '',
    '',
  ]);
  const handleChange = (index, value) => {
    if (!/^\d?$/.test(value)) return; // Allow only single-digit numbers

    const newCode = [...smsConfirmationCode];
    newCode[index] = value;
    setSmsConfirmationCode(newCode);
    setData({
      ...data,
      smsConfirmationCode: newCode.join(''),
      errors: { ...data?.errors, smsConfirmationCode: false },
    });

    if (value && index < 4) {
      document.getElementById(`sms-code-${index + 1}`)?.focus();
    }
  };
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleKeyDown = (event, index) => {
    if (event.key === 'Enter' && data?.newCode?.length >= 4) {
      onSubmit();
      return;
    }
    if (event.key === 'Backspace' && !smsConfirmationCode[index] && index > 0) {
      const newCode = [...smsConfirmationCode];
      newCode[index - 1] = '';
      setSmsConfirmationCode(newCode);
      setData({
        ...data,
        smsConfirmationCode: newCode.join(''),
        errors: { ...data?.errors, smsConfirmationCode: false },
      });
      document.getElementById(`sms-code-${index - 1}`)?.focus();
    }
  };
  const onSubmit = () => {
    setIsLoading(true);
    try {
      LuxService.validatePhoneNumber(data?.smsConfirmationCode, data?.pinId)
        .then(async (response) => {
          console.log('response', response);
          if (response?.data?.verified) {
            const res = await LuxService.isPhoneReturning(data?.phonenumber,flowNumber);
            console.log('isPhoneReturning response', res);
            if (res?.is_returning || res?.user_type?.length) {
              setData({
                ...data,
                user_uuid: res?.user_uuid,
                isReturning: true,
                devices: (/*res?.user_devices || */[]).map((u) => ({
                  src: undefined,
                  code: u?.device_code?.replace(/ /g, ''),
                  name: u?.device_code?.replace(/ /g, ''),
                })),
              });
              setCurrentStep(8);
            } else {
              setData({ ...data, isReturning: false });
              setCurrentStep(currentStep + 1);
            }
          } else throw response;
        })
        .catch((err) => {
          if (data?.smsCodeSentCount < MAX_RETRY) {
            setResendCodeShow(true);
          } else {
            setMaxExceeded(true);
          }
          setSmsConfirmationCode(['', '', '', '', '']);
          setData({
            ...data,
            smsConfirmationCode: '',
            errors: { ...data?.errors, smsConfirmationCode: true },
          });
        });
    } catch (err) {
      if (data?.smsCodeSentCount < MAX_RETRY) {
        setResendCodeShow(true);
      }
      setSmsConfirmationCode(['', '', '', '', '']);

      setData({
        ...data,
        smsConfirmationCode: '',
        errors: { ...data?.errors, smsConfirmationCode: true },
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
        pointerEvents: isLoading ? 'none' : 'all',
      }}
    >
      <ErrorPopUp
        errorText={t('smsConfirmationPage.error')}
        error={data?.errors?.smsConfirmationCode}
        setError={(v) =>
          setData({
            ...data,
            errors: { ...data?.errors, smsConfirmationCode: v },
          })
        }
      />
      {maxExceeded && (
        <div key={smsConfirmationCode}>
          <ErrorPopUp
            errorText={t('smsConfirmationPage.maxExceeded')}
            error={data?.errors?.smsConfirmationCode || maxExceeded}
            setError={(v) => {}}
          />
        </div>
      )}
      <Header steps={steps} currentStep={currentStep} />
      <div
        style={{
          marginTop: '46px',
          display: 'flex',
          flexDirection: 'column',
          paddingInline: '24px',
          alignItems: 'stretch',
        }}
      >
        <div style={{ marginInline: 'auto' }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="66"
            height="81"
            viewBox="0 0 66 81"
            fill="none"
          >
            <rect width="47" height="81" rx="4" fill="#44546A" />
            <rect x="2" y="2" width="43" height="77" rx="2" fill="white" />
            <path
              d="M9 20V27.087V38.1402C9 38.9371 9.88666 39.4139 10.5515 38.9744L14.3352 36.4731C15.3167 35.8242 16.4673 35.4783 17.6439 35.4783H55C61.0751 35.4783 66 30.5534 66 24.4783V20C66 13.9249 61.0751 9 55 9H20C13.9249 9 9 13.9249 9 20Z"
              fill="#00D1D2"
            />
          </svg>
        </div>
        <Typography
          sx={{
            fontSize: '32px',
            fontWeight: '700',
            lineHeight: '38.46px',
            marginTop: '40px',
          }}
        >
          {t('smsConfirmationPage.title')}
        </Typography>
        <Box
          sx={{
            marginTop: '40px',
            display: 'flex',
            flexDirection: 'row',
            gap: '5px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {[0, 1, 2, 3].map((index) => (
            <PrimaryInput
              key={index}
              id={`sms-code-${index}`}
              inputRef={index === 0 ? inputRef : undefined}
              autoFocus={index === 0}
              otherProps={{
                slotProps: {
                  input: {
                    autocomplete: false,
                    endAdornment: <div></div>,
                  },
                },
                autoComplete: 'off',
                inputProps: {
                  inputMode: 'numeric',
                  autoComplete: 'new-password',
                  maxLength: 1,
                  sx: { paddingInline: 0 },
                },
              }}
              value={smsConfirmationCode[index]}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              error={data?.errors?.smsConfirmationCode}
              sx={{
                borderRadius: '4px',
                background: 'white',
                maxHeight: '48px',
                border: data?.errors?.smsConfirmationCode
                  ? '1px solid #FF2D2D'
                  : '',

                '& .Mui-focused': {
                  border: data?.errors?.smsConfirmationCode
                    ? ''
                    : '1px solid #44546A',
                  boxShadow: '0px 0px 0px 4px rgba(0, 0, 0, 0.15)',
                },
                '& .MuiInputBase-input': {
                  color: '#44546A',
                  fontSize: '16px',
                  lineHeight: '21px',
                  fontWeight: '700',
                  border: 'none',
                  textAlign: 'center',
                },
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    border: 'none',
                  },
                  '&:hover fieldset': {
                    border: 'none',
                  },
                  '&.Mui-focused fieldset': {
                    border: 'none',
                  },
                },
                '& .MuiInputBase-input::placeholder': {
                  color: '#44546A',
                  opacity: 0.5,
                  fontSize: '16px',
                  lineHeight: '21px',
                  fontWeight: '500',
                  fontStyle: 'italic',
                  textAlign: 'left',
                },
                width: '40px',
                textAlign: 'center',
                paddingInline: '0',
                '& .MuiInputBase-root': {
                  width: '100%',
                  height: '100%',
                  padding: '0px',
                },
              }}
            />
          ))}
        </Box>
      </div>
      <FloatingActions childrenStyle={{}}>
        <div
          style={{
            paddingInline: '24px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: '16px',
            justifyContent: 'flex-start',
          }}
        >
          {!maxExceeded && resendCodeShow && (
            <SecondaryButton
              style={{}}
              onClick={async () => {
                try {
                  setIsLoading(true);
                  const response = await LuxService.resetPhoneNumberValidation(
                    data?.phonenumber,
                    i18n.language
                  );

                  setData({ ...data, pinId: response?.data?.pinId });
                } catch (err) {
                } finally {
                  setIsLoading(false);
                  setData({
                    ...data,
                    smsCodeSentCount: data?.smsCodeSentCount + 1,
                  });
                  setResendCodeShow(false);
                  setMaxExceeded(data?.smsCodeSentCount > MAX_RETRY);
                }
              }}
              isLoading={isLoading}
            >
              {t('smsConfirmationPage.resendCode')}
            </SecondaryButton>
          )}
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '8px',
            }}
          >
            <button
              onClick={() => {
                setData({ ...data, smsConfirmationCode: '' });
                setCurrentStep(currentStep - 1);
              }}
              style={{
                outline: 'none',
                border: 'none',
                borderRadius: '50%',
                width: '57px',
                height: '57px',
                padding: 0,
                cursor: 'pointer',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="57"
                height="57"
                viewBox="0 0 57 57"
                fill="none"
              >
                <rect
                  opacity="0.1"
                  width="57"
                  height="57"
                  rx="28.5"
                  transform="matrix(-1 0 0 1 57 0)"
                  fill="#44546A"
                />
                <path
                  d="M35 29H22M22 29L27.2 24M22 29L27.2 34"
                  stroke="#44546A"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <PrimaryButton
              style={{ flex: 1 }}
              disabled={data?.smsConfirmationCode?.length !== 4 || maxExceeded}
              onClick={onSubmit}
              isLoading={isLoading}
            >
              {t('continue')}
            </PrimaryButton>
          </div>
        </div>
      </FloatingActions>
    </Box>
  );
}

export default SmsConfirmationPage;
